export default __webpack_public_path__ + "static/media/coinca II plano.acbeec0a.jpg";